var e = require("react"),
    t = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    r = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    n = function n(e, t, r) {
  return 1 == t ? e : r || e + "s";
},
    a = function a(e) {
  if (!e) return new Date();

  if ("number" == typeof e || "" + parseInt(e, 10) == e) {
    if (e = parseInt(e, 10), isNaN(e)) return null;
    e = new Date(1e3 * e);
  }

  if (e = new Date(e), isNaN(e.getTime())) return null;
  var t = e.toJSON().split(/[:\-\+TZ\. ]/);

  for (var r in t) {
    if ("" !== t[r] && isNaN(parseInt(t[r], 10))) return null;
  }

  return e;
},
    u = function u(e, n) {
  var a, u, o;
  void 0 === n && (n = {}), (n = Object.assign({
    format: "full",
    includeDay: !1,
    twentyFourHour: !1
  }, n)).twentyFourHour ? (a = e.getHours().toString(), o = "") : (a = e.getHours() % 12 == 0 ? "12" : (e.getHours() % 12).toString(), o = e.getHours() > 11 ? "pm" : "am"), u = e.getMinutes() < 10 ? "0" + e.getMinutes() : "" + e.getMinutes();
  var i = n.includeDay ? r[e.getDay()] + ", " : "";

  switch (n.format) {
    case "date":
      return "" + i + e.getDate() + " " + t[e.getMonth()] + " " + e.getFullYear();

    case "time":
      return a + ":" + u + o;

    case "json":
      return e.toJSON();

    case "full":
    default:
      return "" + i + e.getDate() + " " + t[e.getMonth()] + " " + e.getFullYear() + ", " + a + ":" + u + o;
  }
};

"function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
  value: function value(e, t) {
    var r = arguments;
    if (null == e) throw new TypeError("Cannot convert undefined or null to object");

    for (var n = Object(e), a = 1; a < arguments.length; a++) {
      var u = r[a];
      if (null != u) for (var o in u) {
        Object.prototype.hasOwnProperty.call(u, o) && (n[o] = u[o]);
      }
    }

    return n;
  },
  writable: !0,
  configurable: !0
}), module.exports = function (t) {
  if (t.autoUpdate) {
    var r = e.useState(0),
        o = r[0],
        i = r[1];
    e.useEffect(function () {
      var e = setInterval(function () {
        return i(o + 1);
      }, 6e4);
      return function () {
        return clearInterval(e);
      };
    }, []);
  }

  var s = t.component || "time",
      l = a(t.date);
  if (!l) return e.createElement(s, {}, ["Invalid date"]);

  var c = l,
      f = function (e, t) {
    return Math.floor((t.getTime() - e.getTime()) / 1e3);
  }(c, a(t.relativeTo) || new Date()),
      d = !t.relative || Math.abs(f) > 31536e3 ? u(c, t.options) : function (e, t) {
    void 0 === t && (t = !0);
    var r,
        a,
        u = e >= 0;
    return e = Math.abs(e), t && e < 60 ? u ? "just then" : "soon" : (a = e < 60 ? e + " " + n("second", e) : e < 3600 ? (r = Math.round(e / 60)) + " " + n("minute", r) : e < 86400 ? (r = Math.round(e / 3600)) + " " + n("hour", r) : e < 604800 ? (r = Math.round(e / 86400)) + " " + n("day", r) : e < 2628e3 ? (r = Math.round(e / 604800)) + " " + n("week", r) : e < 31536e3 ? (r = Math.round(e / 2628e3)) + " " + n("month", r) : (r = Math.round(e / 31536e3)) + " " + n("year", r), t ? u ? a + " ago" : "in " + a : a);
  }(f, !t.relativeTo);

  return e.createElement(s, {
    className: t.className || "",
    style: t.style || {},
    timestamp: u(c, {
      format: "json"
    })
  }, d);
};